<div class="modal-container filter__container d-flex flex-column h-100">
<div class="modal-header d-flex border-0 {{vendorPartLibraryFilters?'justify-content-between':''}}">
  <h1 class="text-primary-color m-0">Filters</h1>
  <div class="d-flex align-items-center clear-color {{vendorPartLibraryFilters?'':'clrFilter'}}"
    (click)="clearAllFilter()">

    <!-- <app-svg-icon [src]="'./assets/SVGIcons/Clearicon.svg'" class="m-r-10">
    </app-svg-icon> -->
    <app-svg iconType="Clear" class="m-r-10 mt-1">
    </app-svg>

    <span class="text-nowrap font-14" type="button">Clear Filters</span>
  </div>
</div>
<div class="modal-body flex-grow-1 row px-2 justify-content-between main-body">
  <ng-container *ngIf="!vendorPartLibraryFilters && !requirementFilters ">
    <div class="col-12 col-md-6 col-lg-5 ps-3 div-two">
      <div class="row row-width">
        <div class="col-12 mini-div-1">
          <div class="row pe-1">
            <div class="col-12 d-flex justify-content-between p-0">
              <div class="d-flex">
                <div class="text-light-gray nowrap me-4 secondary-text ">
                  {{currentTab === "vendor-list" || currentTab === "vendor-contact" ?"Vendor Rating":
                  filterPopupVM.companyRating }}:
                </div>
                <div class="text-primary-color nowrap secondary-text ">
                  {{
                  getAllDropDownModel?.endRating > 0
                  ? getAllDropDownModel?.startRating +
                  " to " +

                  getAllDropDownModel?.endRating +
                  " stars "
                  : "No Range Selected"
                  }}
                </div>
              </div>
              <div class="nowrap p-0 clear-color">
                <div class="hand d-flex" (click)="clearStausBar()">

                  <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                    class="d-flex align-items-center me-2">
                  </app-svg-icon> -->
                  
                      <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>

                  <span class="pe-0 font-14">
                    {{ filterPopupVM.clear }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xl-12 p-0">
              <ngx-slider [(value)]="getAllDropDownModel.startRating" [(highValue)]="getAllDropDownModel.endRating"
                [options]="options">
              </ngx-slider>
              <div class="row mx-1 text-light-gray">
                <div class="col-6 text-start p-0 me-1">
                  <span class="popup-secondary-text ">0</span>
                </div>
                <div class="col d-flex justify-content-end p-0">
                  <span class="popup-secondary-text ">5</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end range slider -->
        <div class="col-12 mt-3 mb-2 mini-div-2">
          <div class="row pe-1">
            <div class="col-8 p-0 text-start">
              <span class="text-light-gray secondary-text "> {{
                currentTab === "vendor-list" || currentTab === "vendor-contact"
                ? filterPopupVM.vendorType
                : filterPopupVM.type
                }}:
              </span>
            </div>
            <div class="col-4 d-flex justify-content-end px-0">
              <div class="hand d-flex clear-color justify-content-center align-items-center"
                (click)="clearSelectedItems(filterPopupVM.class)">
                <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                  class="d-flex align-items-center me-2">
                </app-svg-icon> -->
                 <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>
                
                <span class="font-14">
                  {{ filterPopupVM.clear }}
                </span>
              </div>
            </div>
            <div *ngIf="
              currentTab !== this.enumTabNames.VENDOR_LIST && currentTab !== this.enumTabNames.VENDOR_CONTACT
            " class="col-12 mt-2 p-0 d-flex flex-wrap lable-div align-div">
              <app-button *ngFor="let items of classList; let i = index" [ngClass]="items.isActive ? 'selected' : ''"
                [buttonType]="'button'" (click)="items.isActive = !items.isActive" [buttonClass]="
                'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
              " [spanClass]="'text-truncate'" [button_2]="true" [buttonLable]="items.name">
              </app-button>
            </div>
            <div *ngIf="
              currentTab == this.enumTabNames.VENDOR_LIST || currentTab == this.enumTabNames.VENDOR_CONTACT
            " class="col-12 mt-2 p-0 d-flex flex-wrap lable-div align-div">
              <app-button *ngFor="let items of vendorTypeList; let i = index"
                [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'"
                (click)="items.isActive = !items.isActive" [buttonClass]="
                'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
              " [spanClass]="'text-truncate'" [button_2]="true" [buttonLable]="items.name">
              </app-button>
            </div>
          </div>
        </div>
        <!-- end class -->
        <div class="col-12 mt-3 mb-2 mini-div-3">
          <div class="row pe-1">
            <div class="col-12 col-sm-6 ps-0 d-flex justify-content-between">
              <div class="">
                <span class="text-light-gray secondary-text ">{{ filterPopupVM.active }}: </span>
              </div>
              <div class="">
                <div class="hand d-flex clear-color pe-3 justify-content-center"
                  (click)="clearSelectedItems(filterPopupVM.active)">
                  <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                    class="d-flex align-items-center me-2">
                  </app-svg-icon> -->
                  <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg> 


                  <span class="font-14">
                    {{ filterPopupVM.clear }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 d-flex justify-content-end">
              <div class="hand text-end  includeArchived" *ngIf="currentTab !== this.enumTabNames.VENDOR_LIST">
                <app-checkbox [lableClass]="'text-light-gray'" [lableName]="'Include Archived'"
                  [status]="getAllDropDownModel.archived" (check)="isCheckedInclude()"></app-checkbox>
              </div>
            </div>
            <div class="col-12 col-sm-6 ps-0">
              <div class="col-12 p-0 mt-1 lable-div">
                <div class="d-flex" style="gap: 1.3rem">
                  <app-button *ngFor="let items of activeList; let i = index"
                    [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'" [button_2]="true"
                    (click)="filterStatus(items)" [buttonClass]="
                    'button-lable-primary primary-text mx-0 ps-2  text-center w-5em actInactive btn-hover d-flex align-items-center justify-content-center'
                  " [buttonLable]="items.name">
                  </app-button>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 d-flex justify-content-end">
              <div class="hand text-end mt-1 includeArchived" *ngIf="currentTab !== this.enumTabNames.VENDOR_LIST">
                <app-checkbox [lableClass]="'text-light-gray'" [lableName]="'Include Excluded'"
                  [status]="getAllDropDownModel.excludedFromVendorlist"
                  (check)="isCheckedExclude($event)"></app-checkbox>
              </div>
            </div>

            <!-- <div class="col-2 col-md-3 col-lg-3 col-xl-2 p-0">
            <span class="text-light-gray">{{ filterPopupVM.active }}: </span>
          </div>
          <div class="col-4 col-md-3 col-lg-2 col-xl-4">
            <div
              class="hand d-flex clear-color justify-content-center"
              (click)="clearSelectedItems(filterPopupVM.active)"
            >
              <app-svg-icon
                [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                class="d-flex align-items-center me-2"
              >
              </app-svg-icon>
              <span class="font-11">
                {{ filterPopupVM.clear }}
              </span>
            </div>
          </div>
          <div class="col-12 p-0 mt-2 d-flex justify-content-between lable-div">
            <div class="d-flex" style="gap: 1.3rem">
              <app-button
                *ngFor="let items of activeList; let i = index"
                [ngClass]="items.isActive ? 'selected' : ''"
                [buttonType]="'button'"
                [button_2]="true"
                (click)="filterStatus(items)"
                [buttonClass]="
                  'button-lable-primary font-12 mx-0 ps-2  text-center w-5em actInactive btn-hover d-flex align-items-center justify-content-center'
                "
                [buttonLable]="items.name"
              >
              </app-button>
            </div>
            <div class="hand text-end pe-2 includeArchived"   *ngIf="currentTab !== this.enumTabNames.VENDOR_LIST">
              <app-checkbox
                [lableName]="'Include Archived'"
                [status]="getAllDropDownModel.archived"
                (check)="isCheckedInclude()"
              ></app-checkbox>
            </div>
          </div> -->
          </div>
        </div>
        <!-- end active and inactive  -->
        <div class="col-12 mt-3 mini-div-4">
          <div class="row pe-1 tagsRow">
            <div class="col-8 col-md-8 col-lg-9 col-xl-9 p-0">
              <span class="text-light-gray secondary-text ">
                {{ filterPopupVM.tags }}:
              </span>
            </div>
            <div class="col-4 col-md-4 col-lg-3 col-xl-3 d-flex justify-content-end p-0">
              <div class="hand clear-color d-flex justify-content-center align-items-center"
                (click)="clearSelectedItems(filterPopupVM.tags)">
                <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                  class="d-flex align-items-center me-2">
                </app-svg-icon> -->
                <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>
                
                <span class="font-14">
                  {{ filterPopupVM.clear }}
                </span>
              </div>
            </div>
            <div class="container p-0 mt-2 mb-3 mb-md-0 scrollbar">
              <div class="col-12 p-0 d-flex flex-wrap labl-div align-div">
                <app-button *ngFor="let items of tagsList; let i = index" [ngClass]="items.isActive ? 'selected' : ''"
                  [buttonType]="'button'" [button_2]="true" (click)="items.isActive = !items.isActive" [buttonClass]="
                  'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
                " [spanClass]="'text-truncate'" [buttonLable]="items.name">
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-7 ps-0 ps-md-2 pe-0 div-str">
      <div class="row mx-0 px-0">
        <div class="col-12 col-lg-6 pe-1 ps-1 ps-md-3">
          <div *ngIf="
            currentTab !== this.enumTabNames.VENDOR_LIST && currentTab !== this.enumTabNames.VENDOR_CONTACT
          " class="mb-3">
            <app-multiselect-dropdown
              [listLabel]="enumFilterLabel?.SALESPERSON"
              [list]="getAllDropDownModel?.salesPersonList" [checkedList]="filterCheckList?.salesPerson_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div *ngIf="
            currentTab !== this.enumTabNames.VENDOR_LIST && currentTab !== this.enumTabNames.VENDOR_CONTACT
          " class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.ALT_SALESPERSON"
              [list]="getAllDropDownModel?.altSalesPersonList"
              [checkedList]="filterCheckList?.alt_SalesPerson_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.BUYERS_REP"
              [list]="getAllDropDownModel?.buyerRepList" [checkedList]="filterCheckList?.buyers_Rep_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div *ngIf="
            currentTab !== this.enumTabNames.VENDOR_LIST && currentTab !== this.enumTabNames.VENDOR_CONTACT
          " class="mb-3">
            <!-- <app-multiselect-dropdown
            [listLabel]="enumFilterLabel?.LAST_CONTACTED"
          >
          </app-multiselect-dropdown> -->
            <app-date-picker class="float-contacted" [time]="false" [inputLabel]="enumFilterLabel?.LAST_CONTACTED"
              [inputValue]="contactedDate" (inputValueEmit)="contactedDate = $event"></app-date-picker>
          </div>

          <!-- this belongs to vendor-list only -->
          <div *ngIf="currentTab == this.enumTabNames.VENDOR_LIST || currentTab == this.enumTabNames.VENDOR_CONTACT"
            class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.COUNTRY" [list]="getAllDropDownModel?.countryList"
              [checkedList]="filterCheckList?.country_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div *ngIf="currentTab == this.enumTabNames.VENDOR_LIST || currentTab == this.enumTabNames.VENDOR_CONTACT"
            class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.STATE" [list]="getAllDropDownModel?.stateList"
              [checkedList]="filterCheckList?.state_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div *ngIf="currentTab == this.enumTabNames.VENDOR_LIST || currentTab == this.enumTabNames.VENDOR_CONTACT"
            class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.TIME_ZONE"
              [list]="getAllDropDownModel?.timeZoneList" [checkedList]="filterCheckList?.time_Zone_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div *ngIf="currentTab == this.enumTabNames.VENDOR_LIST || currentTab == this.enumTabNames.VENDOR_CONTACT"
            class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.MANUFACTURER"
              [list]="getAllDropDownModel?.manufacturerList"
              [checkedList]="filterCheckList?.manufacturerList_CheckList">
            </app-multiselect-dropdown>
          </div>
          <!-- this belongs to vendor-list only => Ended -->
        </div>
        <div *ngIf="currentTab !== this.enumTabNames.VENDOR_LIST && currentTab !== this.enumTabNames.VENDOR_CONTACT"
          class="col-12 col-lg-6 pe-1 ps-1 ps-md-3">
          <div class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.COUNTRY" [list]="getAllDropDownModel?.countryList"
              [checkedList]="filterCheckList?.country_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.STATE" [list]="getAllDropDownModel?.stateList"
              [checkedList]="filterCheckList?.state_CheckList">
            </app-multiselect-dropdown>
          </div>

          <div class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.INDUSTRY" [list]="getAllDropDownModel?.industryList"
              [checkedList]="filterCheckList?.industryList_CheckList">
            </app-multiselect-dropdown>
          </div>

          <div class="mb-3">
            <!-- [listLabel]="enumFilterLabel?.STAGE_STATUS" -->
            <!-- [list]="getAllDropDownModel?.stageStatusList" -->
            <!-- [checkedList]="filterCheckList?.stageStatusList_CheckList" -->

            <app-multiselect-dropdown [listLabel]="
              saleStagedata == 'All'
                ? enumFilterLabel?.STAGE_STATUS
                : saleStagedata == 'Lead'
                ? enumFilterLabel?.LEAD_SCORE
                : saleStagedata == 'Prospect'
                ? enumFilterLabel?.PROSPECT_SCORE
                : saleStagedata == 'Customer'
                ? enumFilterLabel?.CUSTOMER_SCORE
                : ''
            " [list]="
              saleStagedata == 'All'
                ? getAllDropDownModel.stageStatusList
                : saleStagedata == 'Lead'
                ? getAllDropDownModel?.leadScoreList
                : saleStagedata == 'Prospect'
                ? getAllDropDownModel?.prospectScoreList
                : ''
            " [checkedList]="
              saleStagedata == 'All'
                ? filterCheckList.stageStatusList_CheckList
                : saleStagedata == 'Lead'
                ? filterCheckList?.leadScoreList_CheckList
                : saleStagedata == 'Prospect'
                ? filterCheckList.prospectScoreList_CheckList
                : ''
            ">
            </app-multiselect-dropdown>
          </div>
        </div>
        <div *ngIf="currentTab == this.enumTabNames.VENDOR_LIST || currentTab == this.enumTabNames.VENDOR_CONTACT"
          class="col-12 col-lg-6 pe-1 ps-1 ps-md-3">
          <div class="hand text-end pe-2 mb-3">
            <app-checkbox [lableClass]="'text-light-gray hand'" [lableName]="'Include “Excluded from Vendor List”'"
              [status]="getAllDropDownModel.excludedFromVendorlist" (check)="isCheckedExclude($event)"></app-checkbox>
          </div>

          <div class="hand text-end pe-2 includeArchived mb-3">
            <app-checkbox [lableClass]="'text-light-gray hand'" [lableName]="'Approved Vendor List (AVL)'"
              [status]="getAllDropDownModel.avl" (check)="AVLId($event)"></app-checkbox>
          </div>
          <div class="hand text-end pe-2 includeArchived mb-3">
            <app-checkbox [lableClass]="'text-light-gray hand'" [lableName]="'Non Approved Vendor List (Non AVL)'"
              [status]="getAllDropDownModel.navl" (check)="NAVLId($event)"></app-checkbox>
          </div>
        </div>
      </div>
      <div *ngIf="currentTab !== this.enumTabNames.VENDOR_LIST && currentTab !== this.enumTabNames.VENDOR_CONTACT"
        class="mb-3 clear-color d-flex justify-content-end pe-2">
        <span class="text-nowrap font-14" type="button" (click)="showMore = !showMore">
          {{ showMore ? "Show More Filters" : "Hide Filters" }}
        </span>
      </div>

      <ng-container
        *ngIf="currentTab !== this.enumTabNames.VENDOR_LIST && currentTab !== this.enumTabNames.VENDOR_CONTACT">
        <div class="pe-md-2">
          <div
            class="col-12 {{ showMore === true ? 'invisible' : 'visible' }}">
            <div class="row mx-0">
              <div class="col-12 col-lg-6 pe-1 ps-1 ps-md-3 mb-3 mb-lg-0">
                <div class="mb-3">
                  <app-multiselect-dropdown [listLabel]="enumFilterLabel?.TIME_ZONE"
                    [list]="getAllDropDownModel?.timeZoneList" [checkedList]="filterCheckList?.time_Zone_CheckList">
                  </app-multiselect-dropdown>
                </div>
                <div>
                  <app-multiselect-dropdown [listLabel]="enumFilterLabel?.SCOPE" [list]="getAllDropDownModel?.scopeList"
                    [checkedList]="filterCheckList?.scope_CheckList">
                  </app-multiselect-dropdown>
                </div>  
              </div>
              <div class="col-12 col-lg-6 pe-1 ps-1 ps-md-3">
                <div class="mb-3">
                  <app-multiselect-dropdown [listLabel]="enumFilterLabel?.SIC_CODE"
                    [list]="getAllDropDownModel?.sicCodeList" [checkedList]="filterCheckList?.sicCodeList_CheckList">
                  </app-multiselect-dropdown>
                </div>
                <div>
                  <app-multiselect-dropdown [listLabel]="enumFilterLabel?.NAICS_CODE"
                    [list]="getAllDropDownModel?.naicsCodeList" [checkedList]="filterCheckList?.naicsCodeList_CheckList">
                  </app-multiselect-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="vendorPartLibraryFilters">
    <!-- ****************VENDORPARTLIBRAY FILTER START*************************** -->
    <ng-container *ngIf="route !== this.routerPath.PARTLIST_ROUTEPATH ;else OtherCondition">
      <div class="ps-3 col-12 col-md-5 col-lg-4 div-two">
        <div class="row row-width">
          <div class="col-12 mini-div-1">
            <div class="row pe-1">
              <div class="col-12 d-flex justify-content-between p-0">
                <div class="d-flex">
                  <div class="text-light-gray nowrap me-4 secondary-text ">{{filterPopupVM.rating}}:</div>
                  <div class="text-primary-color nowrap secondary-text ">
                    {{
                    getAllDropDownModel?.endRating > 0
                    ? getAllDropDownModel?.startRating +
                    " to " +

                    getAllDropDownModel?.endRating +
                    " stars "
                    : "No Range Selected"
                    }}
                  </div>
                </div>
                <div class="nowrap p-0 clear-color">
                  <div class="hand d-flex" (click)="clearStausBar()">
                    <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                      class="d-flex align-items-center me-2">
                    </app-svg-icon> -->
                    <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>
                

                    <span class="pe-0 font-14">
                      {{ filterPopupVM.clear }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xl-12 p-0">
                <ngx-slider [(value)]="getAllDropDownModel.startRating" [(highValue)]="getAllDropDownModel.endRating"
                  [options]="options">
                </ngx-slider>
                <div class="row mx-1 text-light-gray">
                  <div class="col-6 text-start p-0 me-1">
                    <span class="popup-secondary-text ">0</span>
                  </div>
                  <div class="col d-flex justify-content-end p-0">
                    <span class="popup-secondary-text ">5</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end range slider -->
          <div class="col-12 mt-3 mb-2 mini-div-2">
            <div class="row pe-1">
              <div class="col-8 p-0 text-start">
                <span class="text-light-gray secondary-text "> {{filterPopupVM.type}}:
                </span>
              </div>
              <div class="col-4 d-flex justify-content-end px-0">
                <div class="hand d-flex clear-color justify-content-center align-items-center"
                  (click)="clearSelectedItems(filterPopupVM.class)">
                  <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                    class="d-flex align-items-center me-2">
                  </app-svg-icon> -->
                 <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>

                  <span class="font-14">
                    {{ filterPopupVM.clear }}
                  </span>
                </div>
              </div>
              <div *ngIf="route == routerPath.OEM_EXCESS" class="col-12 mt-2 p-0 d-flex flex-wrap lable-div align-div">
                <app-button *ngFor="let items of classList; let i = index" [ngClass]="items.isActive ? 'selected' : ''"
                  [buttonType]="'button'" (click)="items.isActive = !items.isActive" [buttonClass]="
                'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
              " [spanClass]="'text-truncate'" [button_2]="true" [buttonLable]="items.name">
                </app-button>
              </div>
              <div *ngIf="route !== routerPath.OEM_EXCESS" class="col-12 mt-2 p-0 d-flex flex-wrap lable-div align-div">
                <app-button *ngFor="let items of vendorTypeList; let i = index"
                  [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'"
                  (click)="items.isActive = !items.isActive" [buttonClass]="
              'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
            " [spanClass]="'text-truncate'" [button_2]="true" [buttonLable]="items.name">
                </app-button>
              </div>

            </div>
          </div>
          <!-- end active and inactive  -->
          <div class="col-12 mt-3 mini-div-4">
            <div class="row pe-1 tagsRow">
              <div class="col-8 col-md-8 col-lg-9 col-xl-9 p-0">
                <span class="text-light-gray psecondary-text ">
                  {{ route == routerPath.OEM_EXCESS?filterPopupVM.CompanyTags:filterPopupVM.VendorTags }}:
                </span>
              </div>
              <div class="col-4 col-md-4 col-lg-3 col-xl-3 d-flex justify-content-end p-0">
                <div class="hand clear-color d-flex justify-content-center align-items-center"
                  (click)="clearSelectedItems(filterPopupVM.tags)">
                  <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                    class="d-flex align-items-center me-2">
                  </app-svg-icon> -->
                  <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>

                  <span class="font-14">
                    {{ filterPopupVM.clear }}
                  </span>
                </div>
              </div>
              <div class="container p-0 mt-2 mb-3 mb-md-0 scrollbar">
                <div class="col-12 p-0 d-flex flex-wrap labl-div align-div">
                  <app-button *ngFor="let items of tagsList; let i = index" [ngClass]="items.isActive ? 'selected' : ''"
                    [buttonType]="'button'" [button_2]="true" (click)="items.isActive = !items.isActive" [buttonClass]="
                  'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
                " [spanClass]="'text-truncate'" [buttonLable]="items.name">
                  </app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-7 pe-0 mb-3 drop-box">
        <div class="row">
          <div class="col-xl-6 col-md-12 col-lg-12 ps-3 pe-3">
            <div class="mb-3">
              <app-multiselect-dropdown [listLabel]="enumFilterLabel?.MANUFACTURER"
                [list]="getAllDropDownModel?.manufacturerList"
                [checkedList]="filterCheckList?.manufacturerList_CheckList">
              </app-multiselect-dropdown>
            </div>
            <ng-container *ngIf=" route == routerPath.OEM_EXCESS ; else otherCondition">
              <div class="mb-3">
                <app-multiselect-dropdown [listLabel]="'Company'" [list]="getAllDropDownModel?.customerCompanyNameList"
                  [checkedList]="filterCheckList?.company_CheckList">
                </app-multiselect-dropdown>
              </div>
              <div class="mb-3">
                <app-multiselect-dropdown [listLabel]="'Company Contact'" [list]="getAllDropDownModel?.contactNameList"
                  [checkedList]="filterCheckList?.companyContact_CheckList">
                </app-multiselect-dropdown>
              </div>
            </ng-container>
            <ng-template #otherCondition>
              <div class="mb-3">
                <app-multiselect-dropdown [listLabel]="enumFilterLabel?.VENDOR"
                  [list]="getAllDropDownModel?.vendorNameList" [checkedList]="filterCheckList?.vendor_CheckList">
                </app-multiselect-dropdown>
              </div>
              <div class="mb-3">
                <app-multiselect-dropdown [listLabel]="enumFilterLabel?.VENDOR_CONTACT"
                  [list]="getAllDropDownModel?.vendorContactList"
                  [checkedList]="filterCheckList?.vendorContact_CheckList">
                </app-multiselect-dropdown>
              </div>

            </ng-template>
            <div class="mb-3">
              <div class=" ps-0 mb-2 d-flex gap-5">
                <div class="">
                  <span class="text-light-gray secondary-text ">{{ filterPopupVM.active }}: </span>
                </div>
                <div class="">
                  <div class="hand d-flex clear-color pe-3 justify-content-center"
                    (click)="clearSelectedItems(filterPopupVM.active)">
                    <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                      class="d-flex align-items-center me-2">
                    </app-svg-icon> -->
                    <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>
                
                    <span class="font-14">
                      {{ filterPopupVM.clear }}
                    </span>
                  </div>
                </div>
              </div>
              <div [ngStyle]="{'padding-right': route === routerPath.OEM_EXCESS ? '4.5rem' : null }" class="d-flex"
                style="gap: 1.3rem">
                <app-button *ngFor="let items of activeList; let i = index" [ngClass]="items.isActive ? 'selected' : ''"
                  [buttonType]="'button'" [button_2]="true" (click)="filterStatus(items)" [buttonClass]="
                'button-lable-primary primary-text mx-0 ps-2  text-center w-5em actInactive btn-hover d-flex align-items-center justify-content-center'
              " [buttonLable]="items.name">
                </app-button>
              </div>
              <ng-container *ngIf="route !== routerPath.OEM_EXCESS">
                <div [ngStyle]="{ padding: '1rem 2.7rem 0rem 0rem' }" class="py-3">
                  <app-checkbox [lableClass]="'text-light-gray'" [lableName]="'Approved Vendor List (AVL)'"
                    [status]="getAllDropDownModel.avl" (check)="AVLId($event)">
                  </app-checkbox>
                </div>
                <div>
                  <app-checkbox [lableClass]="'text-light-gray'" [lableName]="'Non Approved Vendor List (Non AVL)'"
                    [status]="getAllDropDownModel.navl" (check)="NAVLId($event)">
                  </app-checkbox>
                </div>
              </ng-container>

            </div>
          </div>

          <div class="col-xl-6 col-md-12 col-lg-12 ps-3 pe-2">
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.CATEGORY_GROUP"
                [data]="getAllDropDownModel.categoryGroupList" [selectValue]="data?.categoryGroupId"
                (selectValueEmit)="data.categoryGroupId = $event; onChangedValue($event, enumFilterLabel?.CATEGORY_GROUP)"
                [required]="false">
              </app-dropdown>
            </div>
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.PARENT_CATEGORY"
                [data]="getAllDropDownModel.parentCategoryGroupList" [selectValue]="data?.parentCategoryGroupId"
                (selectValueEmit)="data.parentCategoryGroupId = $event; onChangedValue($event, enumFilterLabel?.PARENT_CATEGORY)"
                [required]="false" [disabled]="!data?.categoryGroupId">
              </app-dropdown>
            </div>
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.CATEGORY" [data]="getAllDropDownModel.inventoryCategoryList"
                [selectValue]="data?.inventoryCategoryId"
                (selectValueEmit)="data.inventoryCategoryId = $event; onChangedValue($event, enumFilterLabel?.CATEGORY)"
                [required]="false" [disabled]="!data?.parentCategoryGroupId">
              </app-dropdown>
            </div>
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.SUB_CATEGORY" [data]="getAllDropDownModel.subCategoryList"
                [selectValue]="data?.subCategoryId" (selectValueEmit)="data.subCategoryId = $event" [required]="false"
                [disabled]="!data?.inventoryCategoryId">
              </app-dropdown>
            </div>

          </div>
        </div>

      </div>
    </ng-container>
    <!-- ****************VENDORPARTLIBRAY FILTER END*************************** -->

    <!-- ****************PARTLIST FILTER START*************************** -->
    <ng-template #OtherCondition>
      <div class="ps-3 col-12 col-md-4 div-two">
        <div class="row row-width">
          <!-- end active and inactive  -->
          <div class="col-12 mini-div-4">
            <div class="row pe-1">
              <div class="col-8 col-md-8 col-lg-9 col-xl-9 p-0">
                <span class="text-light-gray secondary-text ">
                  {{ filterPopupVM.tags }}:
                </span>
              </div>
              <div class="col-4 col-md-4 col-lg-3 col-xl-3 d-flex justify-content-end p-0">
                <div class="hand clear-color d-flex justify-content-center align-items-center"
                  (click)="clearSelectedItems(filterPopupVM.PartInventoryTags)">
                  <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                    class="d-flex align-items-center me-2">
                  </app-svg-icon> -->
                  <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>

                  <span class="font-14">
                    {{ filterPopupVM.clear }}
                  </span>
                </div>
              </div>
              <div class="container p-0 mt-2 mb-3 mb-md-0 scrollbar">
                <div class="col-12 p-0 d-flex flex-wrap labl-div align-div">
                  <app-button *ngFor="let items of partTagsList; let i = index"
                    [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'" [button_2]="true"
                    (click)="items.isActive = !items.isActive" [buttonClass]="
                  'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
                " [spanClass]="'text-truncate'" [buttonLable]="items.name">
                  </app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-7 col-lg-7 col-md-6 px-0 mb-3">
        <div class="row">
          <div class="col-xl-6 col-md-12 col-lg-12 pe-xl-3 ps-xl-1 ps-md-3 pe-md-2 ps-lg-3 pe-lg-2">
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.CATEGORY_GROUP"
                [data]="getAllDropDownModel.categoryGroupList" [selectValue]="data?.categoryGroupId"
                (selectValueEmit)="data.categoryGroupId = $event; onChangedValue($event, enumFilterLabel?.CATEGORY_GROUP)"
                [required]="false">
              </app-dropdown>
            </div>
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.PARENT_CATEGORY"
                [data]="getAllDropDownModel.parentCategoryGroupList" [selectValue]="data?.parentCategoryGroupId"
                (selectValueEmit)="data.parentCategoryGroupId = $event; onChangedValue($event, enumFilterLabel?.PARENT_CATEGORY)"
                [required]="false" [disabled]="!data?.categoryGroupId">
              </app-dropdown>
            </div>
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.CATEGORY" [data]="getAllDropDownModel.inventoryCategoryList"
                [selectValue]="data?.inventoryCategoryId"
                (selectValueEmit)="data.inventoryCategoryId = $event; onChangedValue($event, enumFilterLabel?.CATEGORY)"
                [required]="false" [disabled]="!data?.parentCategoryGroupId">
              </app-dropdown>
            </div>
            <div class="mb-3">
              <app-dropdown [selectLabel]="enumFilterLabel?.SUB_CATEGORY" [data]="getAllDropDownModel.subCategoryList"
                [selectValue]="data?.subCategoryId" (selectValueEmit)="data.subCategoryId = $event" [required]="false"
                [disabled]="!data?.inventoryCategoryId">
              </app-dropdown>
            </div>
          </div>


          <div class="col-xl-6 col-md-12 col-lg-12 ps-md-3 pe-md-2">
            <div class="mb-3">
              <app-multiselect-dropdown [listLabel]="'Part Status'" [list]="getAllDropDownModel?.partStatusList"
                [checkedList]="filterCheckList?.partStatusList_CheckList">
              </app-multiselect-dropdown>
            </div>
            <div class="mb-3">
              <!-- <app-date-picker class="float-contacted" [time]="false" [inputLabel]="enumFilterLabel?.DATE_RANGE"
                [inputValue]="contactedDate" (inputValueEmit)="contactedDate = $event"></app-date-picker> -->

                <app-custom-date-range-picker 
                [inputDate]="dateRangeSelection"
                (selectedDates)="onDateRangeChange($event)" 
                [inputLabel]="enumFilterLabel?.DATE_RANGE">
                </app-custom-date-range-picker>
            </div>

          </div>
        </div>

      </div>

    </ng-template>
    <!-- ****************PARTLIST FILTER END*************************** -->

  </ng-container>
 <!-- *************REQUIREMENT FILTER START **************************** -->
  <ng-container *ngIf="requirementFilters">
    <div class=" col-12 col-md-6 col-lg-6 ps-3 div-two d-sm-flex">
      <div class="row row-width">
        <div class="col-12 mini-div-1">
          <div class="row pe-1">
            <div class="col-8 col-md-8 col-lg-9 col-xl-9 p-0">
              <span class="text-light-gray secondary-text ">
                {{ filterPopupVM.Status }}:
              </span>
            </div>
            <div class="col-4 col-md-4 col-lg-3 col-xl-3 d-flex justify-content-end p-0">
              <div class="hand clear-color d-flex justify-content-center align-items-center"
                (click)="clearSelectedItems(filterPopupVM.Status)">
  
                <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">
                </app-svg>
  
                <span class="font-14">
                  {{ filterPopupVM.clear }}
                </span>
              </div>
            </div>
              <div class="col-12 p-0 d-flex flex-wrap labl-div align-div mt-2">
                <app-button *ngFor="let items of requirementStatusList; let i = index"
                  [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'" [button_2]="true"
                  (click)="items.isActive = !items.isActive" [buttonClass]="
                    'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
                  " [spanClass]="'text-truncate'" [buttonLable]="items.name">
                </app-button>
              </div>
          </div>
        </div>
        <div class="col-12 mt-3 mb-2 mini-div-2">
          <div class="row pe-1">
            <div class="col-8 col-md-8 col-lg-9 col-xl-9 p-0">
              <span class="text-light-gray secondary-text ">
                {{ filterPopupVM.OpportunityType }}:
              </span>
            </div>
            <div class="col-4 col-md-4 col-lg-3 col-xl-3 d-flex justify-content-end p-0">
              <div class="hand clear-color d-flex justify-content-center align-items-center"
                (click)="clearSelectedItems(filterPopupVM.OpportunityType)">
  
                <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">
                </app-svg>
  
                <span class="font-14">
                  {{ filterPopupVM.clear }}
                </span>
              </div>
            </div>
              <div class="col-12 p-0 d-flex flex-wrap labl-div align-div mt-2">
                <app-button *ngFor="let items of opportunityTypeList; let i = index"
                  [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'" [button_2]="true"
                  (click)="items.isActive = !items.isActive" [buttonClass]="
                    'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
                  " [spanClass]="'text-truncate'" [buttonLable]="items.name">
                </app-button>
              </div>
          </div>
        </div>
        <div class="col-12 mt-3 mb-2 mini-div-2">
          <div class="row pe-1">
            <div class="col-8 col-md-8 col-lg-9 col-xl-9 p-0">
              <span class="text-light-gray secondary-text ">
                {{ filterPopupVM.type }}:
              </span>
            </div>
            <div class="col-4 col-md-4 col-lg-3 col-xl-3 d-flex justify-content-end p-0">
              <div class="hand clear-color d-flex justify-content-center align-items-center"
                (click)="clearSelectedItems(filterPopupVM.opportunityBuyType)">
  
                <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">
                </app-svg>
  
                <span class="font-14">
                  {{ filterPopupVM.clear }}
                </span>
              </div>
            </div>
              <div class="col-12 p-0 d-flex flex-wrap labl-div align-div mt-2">
                <app-button *ngFor="let items of opportunityBuyTypeList; let i = index"
                  [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'" [button_2]="true"
                  (click)="items.isActive = !items.isActive" [buttonClass]="
                    'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
                  " [spanClass]="'text-truncate'" [buttonLable]="items.name">
                </app-button>
              </div>
          </div>
        </div>
         <div class="col-12 mini-div-1 mt-3">
          <div class="row pe-1">
            <div class="col-12 d-flex justify-content-between p-0">
              <div class="d-flex">
                <div class="text-light-gray nowrap me-4 secondary-text ">
                  {{filterPopupVM.closeProbability }}:
                </div>
                <div class="text-primary-color nowrap secondary-text ">
                  {{
                  getAllDropDownModel?.endRating > 0
                  ? getAllDropDownModel?.startRating +
                  " to " +

                  getAllDropDownModel?.endRating
                  : "No Range Selected"
                  }}
                </div>
              </div>
              <div class="nowrap p-0 clear-color">
                <div class="hand d-flex" (click)="clearStausBar()">

                  <!-- <app-svg-icon [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                    class="d-flex align-items-center me-2">
                  </app-svg-icon> -->
                  
                      <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">                        
                      </app-svg>

                  <span class="pe-0 font-14">
                    {{ filterPopupVM.clear }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xl-12 p-0">
              <ngx-slider [(value)]="getAllDropDownModel.startRating" [(highValue)]="getAllDropDownModel.endRating"
                [options]="probabilityOptions">
              </ngx-slider>
              <div class="row mx-1 text-light-gray">
                <div class="col-6 text-start p-0 me-1">
                  <span class="popup-secondary-text ">0</span>
                </div>
                <div class="col d-flex justify-content-end p-0">
                  <span class=" popup-secondary-text ">100</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-6 ps-0 ps-md-2 pe-0 div-str">
      <div class="col-12 d-lg-block d-xl-inline-flex">
        <div class="col-12  pe-1 ps-1 ps-md-3">
          <div class="mb-3">
            <app-multiselect-dropdown [listLabel]="enumFilterLabel?.SALESPERSON"
              [list]="getAllDropDownModel?.salesPersonList" [checkedList]="filterCheckList?.salesPerson_CheckList">
            </app-multiselect-dropdown>
          </div>
          <div class="mb-3">
           <!-- <app-date-picker class="float-contacted" [time]="false" [inputLabel]="enumFilterLabel?.REQUIREMENT_DATE"
              [inputValue]="contactedDate" (inputValueEmit)="contactedDate = $event"></app-date-picker> -->
              <app-custom-date-range-picker 
                [inputDate]="dateRangeSelection"
                (selectedDates)="onDateRangeChange($event)" 
                [adjustPopupPosition]="'bottom-right'"
                [inputLabel]="enumFilterLabel?.REQUIREMENT_DATE">
                </app-custom-date-range-picker>
          </div>
          <div class="col-12 mt-3 mb-2 mini-div-2">
          <div class="row ps-3 pe-1">
            <div class="col-8 col-md-8 col-lg-9 col-xl-9 p-0">
              <span class="text-light-gray secondary-text ">
                {{ filterPopupVM.priorityType }}:
              </span>
            </div>
            <div class="col-4 col-md-4 col-lg-3 col-xl-3 d-flex justify-content-end p-0 pe-2">
              <div class="hand clear-color d-flex justify-content-center align-items-center"
                (click)="clearSelectedItems(filterPopupVM.priorityType)">
  
                <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2">
                </app-svg>
  
                <span class="font-14">
                  {{ filterPopupVM.clear }}
                </span>
              </div>
            </div>
              <div class="col-12 p-0 d-flex flex-wrap labl-div align-div mt-2">
                <app-button *ngFor="let items of priorityList; let i = index"
                  [ngClass]="items.isActive ? 'selected' : ''" [buttonType]="'button'" [button_2]="true"
                  (click)="items.isActive = !items.isActive" [buttonClass]="
                    'button-lable-primary primary-text mx-0 ps-2 text-center w-5em btn-hover d-flex justify-content-center align-items-center'
                  " [spanClass]="'text-truncate'" [buttonLable]="items.name">
                </app-button>
              </div>
          </div>
        </div>

        </div>
      </div>
    </div>
  
  </ng-container>
</div>
<div class="modal-footer d-flex border-0">
  <div class="m-0 d-flex gap-3">
    <app-button [buttonType]="'button'" [buttonClass]="'popup-button border-grey'" [buttonLable]="filterPopupVM.cancel"
      (click)="activeModal.close(isSuccess)">
    </app-button>
    <app-button [buttonType]="'button'" [buttonClass]="'popup-button border-theme'" [buttonLable]="filterPopupVM.apply"
      (click)="applyChanges()">
    </app-button>
  </div>
</div>
</div>